import { useState } from 'react';
import { Sparkles, ChevronDown } from 'lucide-react';
import { T, LogoMark, Wordmark } from '../theme';
import { TierAdminBadges, ReportBar, SpendBlock, NavMenu, VersionTag } from './NavShared';

function Header({
  totalSpend, expenses, currentFileName, autoSaving,
  defaultCurrency, adjustmentFactor, ratesLoading, ratesError,
  onPrefsClick, onNewReport, onLoadClick, onExportClick,
  user, onLogout, onLogin, onShareClick, currentFileAccess,
  tier, scansUsed, totalScansAllowed, isAdmin, onAdminClick,
  setAuthScreen, onBillingClick, onInstallClick, onHelpClick,
  onReviewLinksClick, onCreateReviewLinkClick,
  onImportCreditCard, onImportBank, onBusinessSummary, onFinancialSummary, onTaxSummary,
  onBookkeeperClick,
}) {
  const [menuOpen, setMenuOpen] = useState(false);
  const close = () => setMenuOpen(false);

  return (
    <div style={{ background: T.gradNavy, padding: '20px', position: 'relative' }}>

      {/* Top row: logo | user info + menu trigger */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
        <button
          onClick={() => typeof setAuthScreen === 'function' && setAuthScreen('home')}
          style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: 4 }}
          title="Home"
        >
          <LogoMark size={22} />
          <Wordmark size={15} />
        </button>

        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <TierAdminBadges tier={tier} isAdmin={isAdmin} onAdminClick={onAdminClick} />
          <button
            onClick={() => setMenuOpen(o => !o)}
            style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 3, padding: '4px 6px', borderRadius: 6 }}
          >
            <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', fontWeight: 600 }}>
              {user ? (user.displayName || user.email) : 'Guest'}
            </span>
            <ChevronDown size={13} color="rgba(255,255,255,0.5)" />
          </button>
          {onBookkeeperClick && (
            <button
              onClick={onBookkeeperClick}
              title="MySpend AI"
              style={{ background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.25)', borderRadius: 8, padding: '5px 7px', cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            >
              <Sparkles size={16} color="rgba(255,255,255,0.85)" />
            </button>
          )}
        </div>
      </div>

      <div style={{ marginBottom: 4 }}>
        <ReportBar
          currentFileName={currentFileName}
          autoSaving={autoSaving}
          currentFileAccess={currentFileAccess}
          onShareClick={onShareClick}
          onLoadClick={onLoadClick}
          onCreateReviewLinkClick={onCreateReviewLinkClick}
        />
      </div>

      <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 2 }}>
        Total Spend
      </div>
      <SpendBlock
        totalSpend={totalSpend}
        defaultCurrency={defaultCurrency}
        adjustmentFactor={adjustmentFactor}
        ratesLoading={ratesLoading}
        ratesError={ratesError}
        expenses={expenses}
        user={user}
        tier={tier}
        scansUsed={scansUsed}
        totalScansAllowed={totalScansAllowed}
        amountSize={32}
      />

      {/* Dropdown menu */}
      <div onClick={close} style={{ position: 'fixed', inset: 0, zIndex: 199, pointerEvents: menuOpen ? 'all' : 'none' }} />
      <div style={{
        position: 'absolute', top: 10, right: 16,
        transform: menuOpen ? 'translateY(0)' : 'translateY(-10px)',
        opacity: menuOpen ? 1 : 0,
        pointerEvents: menuOpen ? 'all' : 'none',
        zIndex: 200, background: T.navy, borderRadius: 8, padding: 10,
        display: 'flex', flexDirection: 'column', gap: 8,
        minWidth: 200, boxShadow: '0 12px 40px rgba(0,0,0,0.35)',
        transition: 'opacity 0.18s ease, transform 0.18s ease',
      }}>
        <NavMenu
          onClose={close}
          user={user}
          onNewReport={onNewReport}
          onLoadClick={onLoadClick}
          onExportClick={onExportClick}
          onPrefsClick={onPrefsClick}
          onCreateReviewLinkClick={onCreateReviewLinkClick}
          onReviewLinksClick={onReviewLinksClick}
          onBillingClick={onBillingClick}
          onInstallClick={onInstallClick}
          onHelpClick={onHelpClick}
          onLogout={onLogout}
          onLogin={onLogin}
          onImportCreditCard={onImportCreditCard}
          onImportBank={onImportBank}
          onBusinessSummary={onBusinessSummary}
          onFinancialSummary={onFinancialSummary}
          onTaxSummary={onTaxSummary}
        />
        <VersionTag />
      </div>
    </div>
  );
}

export default Header;
